class CartSellingPlan extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.addEventListener("change", (event) => {
      // cart-items listens for bubbling change events to update quantities.
      // Without this the plan id would be read as a quantity value.
      event.stopPropagation();
      this.updateSellingPlan(event.target.value);
    });
  }

  get cartItems() {
    return (
      this.closest("cart-items") ||
      this.closest("cart-drawer-items") ||
      document.querySelector("cart-drawer-items") ||
      document.querySelector("cart-items")
    );
  }

  updateSellingPlan(sellingPlanId) {
    const cartItems = this.cartItems;
    if (!cartItems || typeof cartItems.getSectionsToRender !== "function") return;

    const line = Number(this.dataset.line);
    const quantity = Number(this.dataset.quantity) || 1;
    const sections = cartItems.getSectionsToRender();

    cartItems.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      selling_plan: sellingPlanId === "" ? null : Number(sellingPlanId),
      sections: sections.map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.status) {
          this.showError(parsedState.description);
          return;
        }

        sections.forEach((section) => {
          const container = document.getElementById(section.id);
          if (!container) return;

          const elementToReplace = container.querySelector(section.selector) || container;
          elementToReplace.innerHTML = cartItems.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-selling-plan" });
        document.dispatchEvent(itemQuantityUpdated);
      })
      .catch(() => {
        this.showError();
      })
      .finally(() => {
        cartItems.disableLoading(line);
      });
  }

  showError(message) {
    const text = message || window.cartStrings?.sellingPlanError;
    if (!text) return;

    if (window.patternTheme?.toast) {
      window.patternTheme.toast.error(text);
      return;
    }

    const errorElement = document
      .getElementById(`CartItem-${this.dataset.line}`)
      ?.querySelector(".cart-item__error-text");

    if (errorElement) {
      errorElement.closest(".cart-item__error")?.classList.add("error");
      errorElement.textContent = text;
    }
  }
}

customElements.define("cart-selling-plan", CartSellingPlan);
